export const urls = {
  bambooHr: "https://colearn.bamboohr.com/careers/22?source=aWQ9NzM%3D"
};
